import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { USER_ROUTES } from '../../constants/routeConstants';
import { isKYCCompleted } from '../../utils/kycUtils';

const KYCAlert = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const shouldShowAlert = useMemo(() => {
    if (user?.role === 'super_admin') {
      return false;
    }

    if (!user) {
      return false;
    }
    return !isKYCCompleted(user);
  }, [user]);

  const handleClickHere = () => {
    navigate(`${USER_ROUTES.USER_KYC}`);
  };

  if (!shouldShowAlert) {
    return null;
  }

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-2xl px-4">
      <div className="bg-red-50 border-l-4 border-red-400 px-4 py-2 rounded-lg shadow-lg flex items-center gap-3">
        <AlertCircle className="h-4 w-4 text-red-600 flex-shrink-0" />
        <p className="text-sm text-red-700 flex-1">
          Complete Your KYC Verification - Your KYC verification is incomplete.
          Please complete your identity verification to access all features.
        </p>
        <button
          onClick={handleClickHere}
          className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded-md text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors flex-shrink-0"
        >
          Click Here
        </button>
      </div>
    </div>
  );
};

export default KYCAlert;
